export type Currency = 'UF' | 'CLP';

const CLP_FORMATTER = new Intl.NumberFormat('es-CL', {
  maximumFractionDigits: 0,
});

const UF_FORMATTER = new Intl.NumberFormat('es-CL', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatUF(value: number): string {
  return `UF ${UF_FORMATTER.format(value)}`;
}

export function formatCLP(value: number): string {
  return `$ ${CLP_FORMATTER.format(value)}`;
}

export function formatMoney(value: number, currency: Currency, ufValue: number): string {
  if (currency === 'CLP') {
    return formatCLP(value * ufValue);
  }
  return formatUF(value);
}
